module.exports = __webpack_public_path__ + "static/media/eStar.ad294b2e.svg";